/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
* */

import React from "react";
import AccordianFaq from "./AccordianFaq";

const AccordianFaqContainer = ({
  accordianList
}) => (
  <AccordianFaq accordianList={accordianList} />
);

export default AccordianFaqContainer;
